'use strict';

var RomSummaryDateRangeChartLegendDirective = function RomSummaryDateRangeChartLegendDirective() {
  return {
    restrict: 'E',
    template: require('../templates/rom-summary-date-range-chart-legend.html'),
    controller: 'RomSummaryDateRangeChartLegendController',
    scope: {
      aggregationMode: '=',
      resetChartHandler: '='
    },
    link: function link($scope) {
      $scope.$on('search-criteria:searchChangeEvent', $scope.setDefaultState);
    }
  };
};
RomSummaryDateRangeChartLegendDirective.$inject = [];
module.exports = RomSummaryDateRangeChartLegendDirective;